import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement, useEffect } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { useFullPageDialogContext } from "../../../components/modal/useFullPageDialogContext";
import { OrderConfirmationFormType } from "./ConfirmOrderForm";
import { ConfirmOrderSellarShippingRadioSelector } from "./ConfirmOrderSellarShippingRadioSelector";
import { Alert } from "../../../components/alert/Alert";

export function ConfirmOrderSellarShippingFulfillmentPage({
  form,
  order,
  fulfillmentType,
}: {
  form: UseFormReturn<OrderConfirmationFormType>;
  order?: OrderGetResponseType;
  fulfillmentType: OrderGetResponseType["fulfillmentType"];
}): ReactElement | null {
  const { scrollToTop } = useFullPageDialogContext();

  // Scroll to top when this page is mounted
  useEffect(() => {
    scrollToTop?.();
  }, [scrollToTop]);

  const dispatchPlannedAt = useWatch({
    control: form.control,
    name: "dispatchPlannedAt",
  });

  const isUpsSelected = fulfillmentType === "ups";

  const upsAlert = isUpsSelected ? (
    <Alert
      type="information"
      title={
        "All items MUST be boxed to avoid additional handling charges from UPS. This includes plastic kegs."
      }
      message=""
      className="w-full"
    />
  ) : null;

  return (
    <>
      <ConfirmOrderSellarShippingRadioSelector
        order={order}
        dispatchPlannedAt={dispatchPlannedAt}
        onChange={(fulfillmentType) =>
          form.setValue(
            "fulfillmentType",
            fulfillmentType as OrderGetResponseType["fulfillmentType"],
          )
        }
        value={fulfillmentType}
        required={true}
        upsAlert={upsAlert}
      />
    </>
  );
}
